/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Entity_TeamInputs */

const cs_enum_entity_team = /** @type {(inputs: Enum_Entity_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tým`)
};

const en_enum_entity_team = /** @type {(inputs: Enum_Entity_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

/**
* | output |
* | --- |
* | "Team" |
*
* @param {Enum_Entity_TeamInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_entity_team = /** @type {((inputs?: Enum_Entity_TeamInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Entity_TeamInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_entity_team(inputs)
	return cs_enum_entity_team(inputs)
});